"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.getCharCode = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Icon_types_1 = require("./Icon.types");
function getCharCode(name) {
    const code = parseInt(Icon_types_1.Icons[name]);
    return String.fromCharCode(code);
}
exports.getCharCode = getCharCode;
exports.StyledIcon = styled_components_1.default.i.withConfig({
    shouldForwardProp: (prop) => !["name", "rotate", "variant"].includes(prop),
}) `
  line-height: 1;
  font-style: normal;
  &:before {
    font-family: iconfont !important;
    font-style: normal;
    // font-weight: normal !important;
    // vertical-align: text-top;
    vertical-align: middle;
    display: inline-block;
    content: "${({ name }) => getCharCode(name)}";
    transition: transform 0.3s;
    ${({ rotate }) => {
    let transform;
    switch (rotate) {
        case "right":
            transform = "transform: rotate3d(0, 0, 1, 90deg) ";
            break;
        case "left":
            transform = "transform: rotate3d(0, 0, 1, -90deg)";
            break;
        case "bottom":
            transform = "transform: rotate3d(0, 0, 1, 180deg) ";
            break;
    }
    return (transform &&
        (0, styled_components_1.css) `
          ${transform}
        `);
}}
  }
`;
//# sourceMappingURL=styled.js.map